

export function isChinese(){
    let lang = localStorage.getItem('lang')
   if (!lang ) {
       lang = 'zh'
   }
    return lang === 'zh'
}